import { useId, useRef, type ReactNode } from "react";
import { X } from "lucide-react";
import { Button } from "./Button";
import { useDialogA11y } from "./useDialogA11y";

type ModalSize = "sm" | "md" | "lg" | "fullscreen";

interface ModalProps {
  open: boolean;
  title: ReactNode;
  size?: ModalSize;
  onClose: () => void;
  footer?: ReactNode;
  children: ReactNode;
}

export function Modal({ open, title, size = "md", onClose, footer, children }: ModalProps) {
  const dialogRef = useRef<HTMLElement | null>(null);
  const titleId = useId();
  useDialogA11y(open, dialogRef, onClose);
  if (!open) return null;
  return (
    <div className="ds-modal-overlay" role="presentation" onMouseDown={onClose}>
      <section
        ref={dialogRef}
        className={`ds-modal ds-modal-${size}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="ds-modal-header">
          <h2 id={titleId}>{title}</h2>
          <Button variant="ghost" size="sm" icon={<X size={18} />} aria-label="Ёпиш" onClick={onClose} />
        </header>
        <div className="ds-modal-body">{children}</div>
        {footer && <footer className="ds-modal-footer">{footer}</footer>}
      </section>
    </div>
  );
}

